export const environment = {
  production: false,
  keycloakClientId:'frontend_bme-legal',
  keycloakUrl: 'https://stg.arrowheadcopilot.online/keycloak/',
  keycloakRealm:'bme',
  serviceUrl: "https://stg.arrowheadcopilot.online/v1",
  documentServiceUrl: "/bme-legal-documents",
  chatServiceUrl: "/bme-legal-chatbot/",
  plannerServiceUrl: "/planner",
  pluginServiceUrl: "/config/plugins",
  templateServiceUrl: "/config/templates",
  ragServiceUrl: "/bme-legal-rag/",
  exitPeriod: 3000000,
  logo: "bme.png",
  chatLogo:"bme.png",
  baseHref: '/',
  menu: {
    chat: false,
    documents: false,
    templates: false,
    plugins: false,
    plan: false,
    ragflow: true
  },
  defaultMenu: 'ragflow',
  login:true, 
  standalone: false,
  standaloneServiceUrlForPlanner: '',
  standaloneServiceUrlForConfig: '',
  autoSilentRag: true,
  autoSilentPlanner: true,
  ragFLowServiceUrl:  "https://bmelegal.stg2.arrowheadcopilot.online/chats/share?shared_id=821d948855e711f091b99aff265c4fd3&from=chat&auth=RjMzZkNTY2NTVlNjExZjA4MGIyOWFmZj&theme=light"
};
